import { render, staticRenderFns } from "./DataDeletionRequests.vue?vue&type=template&id=cb27ce0e&scoped=true"
import script from "./DataDeletionRequests.vue?vue&type=script&lang=js"
export * from "./DataDeletionRequests.vue?vue&type=script&lang=js"
import style0 from "./DataDeletionRequests.vue?vue&type=style&index=0&id=cb27ce0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb27ce0e",
  null
  
)

export default component.exports